/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Lead_CtaInputs */

const en_cp_p_lead_cta = /** @type {(inputs: Cp_P_Lead_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply as Campus Lead`)
};

const id_cp_p_lead_cta = /** @type {(inputs: Cp_P_Lead_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar Campus Lead`)
};

/**
* | output |
* | --- |
* | "Apply as Campus Lead" |
*
* @param {Cp_P_Lead_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_lead_cta = /** @type {((inputs?: Cp_P_Lead_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Lead_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_lead_cta(inputs)
	return en_cp_p_lead_cta(inputs)
});